module.exports = __webpack_public_path__ + "img/panelView_blueBg_2_3.d3d2914f.png";